function initHowItWorksSection( section )
{
    const track      = section.querySelector( ".we-hiw__track" );
    const prevButton = section.querySelector( ".we-hiw__arrow--prev" );
    const nextButton = section.querySelector( ".we-hiw__arrow--next" );

    if ( track && prevButton && nextButton && section.dataset.hiwInitialized != "true" )
    {
        function handleHowItWorksPrev()
        {
            scrollTrackByCard( track, ".we-hiw__card", -1 );
        }

        function handleHowItWorksNext()
        {
            scrollTrackByCard( track, ".we-hiw__card", 1 );
        }

        prevButton.addEventListener( "click", handleHowItWorksPrev );
        nextButton.addEventListener( "click", handleHowItWorksNext );
        section.dataset.hiwInitialized = "true";
        if ( section.dataset.quizResume == "true" )
        {
            applyQuizResumeVariant( section, ".we-hiw__cta" );
        }
    }
}

function initHowItWorks()
{
    const sections = document.querySelectorAll( ".we-hiw" );
    sections.forEach( initHowItWorksSection );
}

document.addEventListener( "DOMContentLoaded", initHowItWorks );
